import header from "./components/header";
import slider from "./components/slider";
import scrollTop from "./components/scrollTop";
import social from "./components/social";
import wSearch from "./components/widgetSearch";
import news from "./components/news";
import videoBlock from "./components/videoBlock";
import hpSlider from "./components/hpSlider";
import videoHome from "./components/videoHome";
import {Cursor} from "./anims/Cursor";
import {bContact} from "./components/bContact";
import {bFaq} from "./components/bFaq";
import bTeam from "./components/bTeam";
import form from "./components/form";
import tint from "./components/tint";
import nlForm from './components/nl_form';
import iframe from './components/iframe';

// anims
import aos from "./anims/appear-on-scroll";
import headerSearch from "./components/header-search";

// general
import {titlesArticles} from "./general/text";
import img from './general/img';
import moveElements from './general/moveElements';

const main = {
    init: function () {
        slider.init();          // block slider
        scrollTop.init();       // scrollTop
        social.init();          // sticky social : toggle
        videoBlock.init();      // play/pause des blocs vidéos
        videoHome.init();       // vidéos de la home + timeline
        hpSlider.init();  // slider d'actualités HP - écran 1
        nlForm.init()
        form.init();            // check fields and submit form
        moveElements.init();    // move elements that has to be in another place for mobile devices
        iframe.init();          // change iframe height with devices

        // let cursor = null;
        let isIE11 = !!window.MSInputMethodContext && !!document.documentMode;
        if(!isIE11) {
            new Cursor({
                minWidth: '1025px',
                framerate: 10
            });
        }

        main.onLoad();          // when DOM is loaded
        main.onScroll();        // check le scroll de la page
        main.onResize();        // check les resize de page
    },
    onLoad: function () {
        // lorsque la page est entièrement chargée
        window.addEventListener('load', function () {
            header.init();           // navigation + sharing from header
            headerSearch.init();
            wSearch.init();          // widgetSearch
            aos.init();              // elements appear with animation on scroll
            img.init();
            bContact.init();         // component bContact
            bTeam.init();            // component bTeam
            bFaq.init();            // component bFAQ
            titlesArticles.init();   // text fit
            tint.init();

           
        });
        document.addEventListener('readystatechange', function(){
            switch (document.readyState) {
            //   case 'loading':
            //   case 'interactive':
            //   case 'loaded':
                case 'complete':
                    news.init();
                    break;
      
                default:
                    break;
            }
        });
        window.onYouTubeIframeAPIReady = function () {
            setTimeout(videoBlock.onYouTubeIframeAPIReady, 500);
            setTimeout(videoHome.onYouTubeIframeAPIReady, 500);
        };
    },
    onScroll: function () {
        // lorsque la page est entièrement chargée
        window.addEventListener('scroll', function () {
            // lister ici fonctions qui ont besoin d'être (re)chargées au scroll
            scrollTop.display();
            if (window.matchMedia("(max-width: 1099px)").matches) {
                slider.setFullHeight();
            }
        });
    },
    onResize: function () {
        let originalResize = evt => {
            // lister ici fonctions qui ont besoin d'être (re)chargées au resize
            header.toggleNavOnResize();
            header.setSubStyle();
            iframe.init();
        };

        let resizeTaskId = null;
        // lorsque l'internaute modifie la taille de sa fenêtre
        window.addEventListener('resize', evt => {
            if (resizeTaskId !== null) {
                clearTimeout(resizeTaskId);
            }

            resizeTaskId = setTimeout(() => {
                resizeTaskId = null;
                originalResize(evt);
            }, 100);
        });
    }
}

export default main;


// WEBPACK FOOTER //
// ./src/scripts/main.js